module.exports = __webpack_public_path__ + "static/media/calendar-with-event.f97cb634.svg";